import { render, staticRenderFns } from "./GridTV.vue?vue&type=template&id=4addc52c&scoped=true"
import script from "./GridTV.vue?vue&type=script&lang=js"
export * from "./GridTV.vue?vue&type=script&lang=js"
import style0 from "./GridTV.vue?vue&type=style&index=0&id=4addc52c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4addc52c",
  null
  
)

export default component.exports